import { useRef } from "react";
import { Page, Popup } from "framework7-react";
import PopupNavbar from "../../components/popup-navbar";
import { usePopupBackClose } from "../../hooks/use-back-close";
import Settlement from ".";

const sameId = (a, b) => a != null && b != null && `${a}` === `${b}`;

const SettlementPopup = ({ group, groupId, opened, onClose }) => {
  const backClose = usePopupBackClose(opened);
  const isCurrent = sameId(group?.id, groupId);
  const shownGroup = useRef(null);
  if (isCurrent) shownGroup.current = group;

  return (
    <Popup
      {...backClose}
      className="settlement-popup"
      opened={opened}
      onPopupClosed={onClose}
    >
      <Page>
        <PopupNavbar title="Abrechnung" />
        <div className="settlement-popup-content">
          <Settlement
            group={isCurrent ? group : shownGroup.current}
            active={opened && isCurrent}
          />
        </div>
      </Page>
    </Popup>
  );
};

export default SettlementPopup;
